var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "tableContainer",
      staticStyle: {
        padding: "4px",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      },
      style: _vm.bg_class,
    },
    [
      _c("view-track-bar", {
        ref: "viewTrack",
        staticClass: "track-bar",
        style: _vm.trackBarStyleTime,
        attrs: { "track-menu": _vm.trackMenu },
        on: { trackClick: _vm.trackClick },
      }),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.title_show,
              expression: "title_show",
            },
          ],
          ref: "title",
          staticStyle: { cursor: "default", display: "block" },
          style: _vm.title_class,
        },
        [
          _c(
            "div",
            [
              _c("chart-title-update", {
                attrs: {
                  "title-class": _vm.title_class,
                  "chart-info": _vm.chartInfo,
                },
              }),
              _vm.chart.render &&
              _vm.chart.render === "antv" &&
              _vm.remarkCfg.show
                ? _c("title-remark", {
                    staticStyle: {
                      "text-shadow": "none!important",
                      "margin-left": "4px",
                    },
                    attrs: { "remark-cfg": _vm.remarkCfg },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.chart.data &&
      _vm.chart.data.series &&
      _vm.chart.data.series.length > 0
        ? _c(
            "div",
            { style: _vm.content_class, attrs: { id: "label-content" } },
            [
              _c("span", { style: _vm.label_class }, [
                _vm.chart.data.series[0].data &&
                _vm.chart.data.series[0].data.length > 0
                  ? _c(
                      "p",
                      {
                        ref: "textData",
                        style: _vm.label_content_class,
                        on: { click: _vm.textClick },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.chart.data.series[0].data[0]) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm.dimensionShow
                ? _c("span", { style: _vm.label_space }, [
                    _c("p", { style: _vm.label_class }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.chart.data.series[0].name) +
                          "\n      "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }